// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2RGJZ","alertIcon":"ConfirmModal_alertIcon__306H6"};